(function () {
    'use strict';

    angular.module("imApp").factory("paymentsService", ['$ihttp', function ($ihttp) {
        let service = {
            listPayments: function (parms) {
                return $ihttp.post({
                    method: 624,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
